/*
 * Ryan O'Dowd
 * 2026-07-11
 * © Copyright 2026 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */

const getStyles = ({globalScale, fonts, colors}) => {
  return {
    verseWrapper: { // @TODO: clean up these when this jsx is abstracted out
      display: 'flex',
      flexDirection: 'column',
      borderLeftStyle: 'solid',
      borderLeftWidth: 2,
      color: colors.extraLightGray,
      borderLeftColor: colors.primaryExtraLight,
      marginBottom: globalScale * 16,
      padding: 8,
      paddingTop: 2,
      paddingBottom: 2,
      paddingLeft: 8,
    },
    verseBody: {
      fontFamily: fonts.primaryItalic,
      fontSize: globalScale * 12,
      display: 'inline',
      color: colors.white,
    },
    bold: {
      fontFamily: fonts.primaryBoldItalic,
      color: colors.accent,
    },
    reference: {
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 14,
      marginTop: 4,
      color: colors.white,
    },
    introTextWrapper: {
      display: 'flex',
      flexDirection: 'row',
    },
    introText: {
      display: 'ruby', // @TODO: better way to keep this inline
      color: colors.white,
      marginBottom: globalScale * 16,
    },
    namePrimaryText: {
      fontFamily: fonts.primaryBold,
      fontSize: globalScale * 14,
      color: colors.dialogText,
    },
    nameSecondaryText: {
      fontFamily: fonts.secondary,
      fontSize: globalScale * 12,
      color: colors.dialogText,
    },
    abbreviationText: {
      fontFamily: fonts.primary,
      fontSize: globalScale * 12,
      textAlign: 'right',
    },
    localeWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
    },
    localePrimaryText: {
      fontFamily: fonts.primary,
      fontSize: globalScale * 12,
      color: colors.dialogText,
      textAlign: 'right',
    },
    localeSecondaryText: {
      fontFamily: fonts.secondary,
      fontSize: globalScale * 10,
      color: colors.dialogText,
      textAlign: 'right',
    },
    dialogTextTitle: {
      fontFamily: fonts.primaryBold,
      color: colors.dialogText,
    },
    dialogText: {
      color: colors.dialogText,
    },
    dialogSpacer: {
      height: 40,
    },
  };
};

export default getStyles;
